// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__UsBKO","detailsBorder":"styles_detailsBorder__NSgYy"};